<div [formGroup]="formGroup()" class="metadata-form-wrapper">
    <div formGroupName="consumerData" class="consumer-data-container">
        @for (meta of metaData; track meta.id) {
            <div class="metadata-group">
                <h3 class="group-title">{{ meta.name }}</h3>

                <div class="fields-grid">
                    @for (field of meta.fieldConf; track field.name) {
                        <div class="field-item" [class.full-width]="field.datatype === 'FunctionalHelp'">
                            @switch (field.datatype) {
                                @case (dataTypes.String) {
                                    <mat-form-field>
                                        <input type="text" matInput [formControlName]="field.name" />
                                    </mat-form-field>
                                }
                                @case (dataTypes.Int) {
                                    <mat-form-field>
                                        <input type="number" matInput [formControlName]="field.name" />
                                    </mat-form-field>
                                }
                                @case (dataTypes.Float) {
                                    <mat-form-field>
                                        <input type="number" matInput [formControlName]="field.name" step="any" />
                                    </mat-form-field>
                                }
                                @case (dataTypes.UnsignedIntStepper) {
                                    <mat-form-field>
                                        <input type="number" matInput [formControlName]="field.name" min="0" />
                                    </mat-form-field>
                                }
                                @case (dataTypes.CheckBox) {
                                    <div class="checkbox-container">
                                        <mat-slide-toggle [formControlName]="field.name">
                                        </mat-slide-toggle>
                                    </div>
                                }
                                @case (dataTypes.FunctionalHelp) {
                                    <div class="functional-help-container" formGroupName="functionalHelp">
                                        <!-- Hidden ID field -->
                                        <input type="hidden" formControlName="id" />

                                        <div class="help-header">
                                            <button mat-stroked-button color="primary" (click)="showFunctionalHelp()">
                                                <mat-icon>help_outline</mat-icon>
                                                {{ field.label | transloco }}
                                            </button>

                                            @if (functionalHelpName()) {
                                                <div class="function-help-name">
                                                    {{ functionalHelpName() }}
                                                </div>
                                            }
                                        </div>

                                        <div class="help-options">
                                            <mat-checkbox formControlName="showHelpOnStart">
                                                {{ "show_helo_on_start" | transloco }}
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                }
                                @case (dataTypes.SingleSelection) {
                                    <mat-form-field>
                                        <mat-select [formControlName]="field.name">
                                            <mat-option [value]="null">--</mat-option>
                                            @for (option of field.subFieldConf; track option) {
                                                <mat-option [value]="option.name">{{ option.label | transloco }}</mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                }
                                @default {
                                    <mat-accordion>
                                        <mat-expansion-panel>
                                            <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    {{ field.label | transloco }}
                                                </mat-panel-title>
                                                <mat-panel-description>
                                                    <small>DataType '{{ field.datatype }}' not implemented</small>
                                                </mat-panel-description>
                                            </mat-expansion-panel-header>
                                            <p style="max-width: 560px; overflow-x: scroll">{{ field | json }}</p>
                                        </mat-expansion-panel>
                                    </mat-accordion>
                                }
                            }
                        </div>
                    }
                </div>
            </div>
        }
    </div>
</div>
